var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"facebookUpload"},[_c('el-upload',{attrs:{"action":"","show-file-list":false,"http-request":_vm.uploadSectionFile,"before-upload":_vm.beforeAvatarUpload,"accept":_vm.accept,"disabled":_vm.disabled}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }